<template>
  <div
    class="legal-layout bg-white"
    :class="{ 'is-majority-browser': isMajorityBrowser }"
  >
    <LayoutTheHeader />
    <div class="container legal_container pt-6">
      <BlocksHeroBreadcrumbs
        v-if="!isMajorityBrowser"
        :breadcrumbs="breadcrumbs"
        class="breadcrumbs mt-2 md:mt-8 mb-8 md:mb-10"
      />
    </div>
    <slot class="legal-layout-content pb-10 lg:pb-18" />
    <LayoutTheFooter />
    <SharedCookieBanner />
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { metaHreflang } from '@/utils/metaHreflang'
import { applicationStore } from '@/store/application'

export default {
  computed: {
    ...mapState(applicationStore, ['isMajorityBrowser']),
    breadcrumbs () {
      const breadcrumbs = [
        {
          title: this.$messages('label.home'),
          to: this.$mRouter.getLocalRoute({ name: 'index' })
        },
        {
          title: this.$messages('page_labels.legal_terms_of_use'),
          to: this.$mRouter.getLocalRoute({ name: 'terms-of-use' })
        }]
      if (this.$route.meta.routeKey !== 'legal_terms_of_use') {
        breadcrumbs.push({
          title: this.$route.meta.routeKey
        })
      }
      return breadcrumbs
    }
  },
  methods: {
    canonical () {
      return {
        rel: 'canonical',
        href: process.env.websiteUrl + this.$route.path
      }
    },
    hreflang () {
      return [
        ...metaHreflang(this.$route, this.$router),
        ...['en', 'es'].map((key) => {
          return {
            rel: 'alternate',
            hreflang: key,
            href: this.$env.websiteUrl + `${this.$mRouter.resolveLocalRoute({ name: this.$route.matched[0].meta.key }, key).href}`
          }
        })
      ]
    }
  }
}
</script>

    <style lang="postcss">
    .legal_container{
      margin-top: var(--navbar-height);
    }
    /* only in mobile app */
    .is-majority-browser {
      padding-left: 0 !important;
      padding-right: 0 !important;
      padding-top: 42px !important;
      h1 {
        text-transform: unset !important;
        font-size: 32px !important;
        font-family: "GT-AMERICA" !important;
        font-weight: bold !important;
      }
      .index-title {
        letter-spacing: -0.1px;
        margin-bottom: 40px !important;
      }
      .container {
        padding-left: 24px !important;
        padding-right: 24px !important;
      }
      #LegalIndex {
        h2 {
          font-weight: bold;
          letter-spacing: 0.5px;
          margin-bottom: 10px;
        }
        a {
          padding: 10px 0;
          display: block;
          margin: 1px 0;
          letter-spacing: -0.1px;
          color: #794dff;
          text-decoration: none;
        }
        .section {
          &:not(:last-child) {
            padding-bottom: 20px;
            margin-bottom: 30px;
            border-bottom: 1px solid #f4f0ee;
          }
        }
      }
      h1:not(.index-title) {
        line-height: 36px;
        margin-bottom: 22px !important;
      }
    }

    /* only regular browser desktop */
    .legal-layout:not(.is-majority-browser) {
      .hero-breadcrumbs-wrapper {
        margin-top: 34px !important;
      }
      .index-title {
        font-size: 88px !important;
        margin-top: 50px !important;
        display: block;
        letter-spacing: 3.7px !important;
        margin-bottom: 45px !important;
      }
      #LegalIndex {
        h2 {
          letter-spacing: 2.5px;
          font-size: 20px;
          margin-bottom: 16px;
          text-transform: uppercase !important;
        }
        a {
          padding: 10px 0;
          display: block;
          margin: 7px 0;
          letter-spacing: 1px;
          color: #794dff;
          text-decoration: underline;
          &:hover {
            text-decoration: none;
          }
        }
        .section {
          &:not(:last-child) {
            margin-bottom: 42px;
          }
        }
      }
      h1:not(.index-title) {
        text-transform: unset !important;
        margin-top: 66px;
        font-family: "GT-AMERICA" !important;
        font-weight: bold !important;
        font-size: 64px !important;
        letter-spacing: 2.6px;
        margin-bottom: 75px !important;
      }
    }

    /* only regular browser mobile */
    @media (max-width: 768px) {
      .legal-layout:not(.is-majority-browser) {
        .hero-breadcrumbs-wrapper {
          margin-top: 6px !important;
          margin-bottom: 0 !important;
        }
        .index-title {
          font-size: 36px !important;
          margin-top: 32px !important;
          font-weight: bold;
          letter-spacing: 2px !important;
          margin-bottom: 50px !important;
        }

        h1:not(.index-title) {
          margin-top: 16px;
          font-size: 32px !important;
          letter-spacing: -0.5px;
          margin-bottom: 36px !important;
          line-height: 1.3;
        }

        #LegalIndex {
          h2 {
            letter-spacing: 1px;
            font-size: 19px;
          }
          a {
            padding: 6px 0;
          }
        }
      }
    }
    </style>

    <style>
    @import "@/assets/css/local/markdown.css";
    *,
    *:before,
    *:after {
      box-sizing: border-box;
      margin: 0;
    }
    </style>
